import { kitStorageTips } from '../../../mocks/preparedness';

export default function StorageTips() {
  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Kit Storage Best Practices
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Proper storage ensures your emergency supplies are ready when you need them most.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {kitStorageTips.map((tip, index) => (
            <div key={index} className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-orange-100 to-red-100 rounded-full mb-4">
                <i className={`${tip.icon} text-4xl text-orange-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{tip.title}</h3>
              <p className="text-gray-600 leading-relaxed">{tip.description}</p>
            </div>
          ))}
        </div>

        {/* Additional Tips Box */}
        <div className="mt-12 bg-gradient-to-br from-orange-50 to-red-50 rounded-lg p-8 border border-orange-200">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center">
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Pro Tips</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-600 mt-1"></i>
                  <span>Rotate food and water supplies every 6 months to ensure freshness</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-600 mt-1"></i>
                  <span>Test batteries and replace them annually, even if unused</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-600 mt-1"></i>
                  <span>Keep a smaller "go bag" in your car with essential items</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-600 mt-1"></i>
                  <span>Store important documents in waterproof, fireproof containers</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
